import React, { useContext, useState, useEffect } from 'react';
import { useTable } from 'react-table';
import { Context } from './Context';
import TableData from './TableData';
import TableHeader from './TableHeader';
import base from '../api/base';

let fnp = null;

function Table() {
  const {
    state: {
      selected: { brandSelected, modelSelected },
    },
  } = useContext(Context);

  const [records, setRecords] = useState([]);

  useEffect(() => {
    setRecords([]);

    let filterString = null;

    if (brandSelected.value && modelSelected.value) {
      filterString =
        "AND({carBrand} = '" +
        brandSelected.value +
        "', " +
        `FIND((LEFT("${modelSelected.value.toLowerCase()}", ${
          modelSelected.value.length
        })), LOWER(carModel)) > 0` +
        ')';
    } else if (brandSelected.value) {
      filterString = "({carBrand} = '" + brandSelected.value + "')";
    }

    base('data')
      .select({
        view: 'Grid view',
        pageSize: 10,
        filterByFormula: filterString || '',
      })
      .eachPage((records, fetchNextPage) => {
        setRecords((prevState) => [...prevState, ...records]);

        fnp = fetchNextPage;
      });
  }, [brandSelected, modelSelected]);

  const data = React.useMemo(() =>
    records
      .filter((brand) => {
        // Only show records that have at least carBrand and carModel
        const { carBrand, carModel } = brand.fields;
        return carBrand && carModel;
      })
      .map((brand) => {
        const {
          carBrand,
          carModel,
          Typ,
          name,
          batterieGewicht,
          vRB_Tarifkategorie,
          vRB_CHF,
          nationalcode,
        } = brand.fields;

        return {
          key: nationalcode,
          col1: carBrand,
          col2: carModel,
          col2b: Typ,
          col3: name,
          col6: batterieGewicht,
          col7: vRB_Tarifkategorie,
          col8: vRB_CHF,
        };
      })
  );

  const columns = React.useMemo(
    () => [
      {
        Header: 'Hersteller',
        accessor: 'col1',
      },
      {
        Header: 'Modell',
        accessor: 'col2',
      },
      {
        Header: 'Typ',
        accessor: 'col2b',
      },
      {
        Header: 'Modellstart',
        accessor: 'col3',
      },
      {
        Header: 'Batteriegewicht',
        accessor: 'col6',
      },
      {
        Header: 'SENS Kategorie',
        accessor: 'col7',
      },
      {
        Header: 'vRB pro Fahrzeug',
        accessor: 'col8',
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  return (
    <>
      <div className='board__wrapper'>
        <table {...getTableProps()} className='board'>
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr key={`header-group-${index}`} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => {
                  return <TableHeader key={column.id} column={column} />;
                })}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);

              return (
                <tr key={row.id} {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return <TableData key={cell.id} row={row} cell={cell} />;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        {records.length >= 10 && (
          <button className='button' onClick={() => fnp()}>
            <span className='button__link'>mehr laden</span>
          </button>
        )}
      </div>
    </>
  );
}

export default Table;
